export enum FirebaseErrorCode {
  NOT_FOUND = 5
}
